import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["trigger", "dropdown", "search", "option", "preview", "input"]

  connect() {
    this.selected = ""
  }

  toggle(event) {
    event.preventDefault()
    this.dropdownTarget.classList.toggle("hidden")
    if (!this.dropdownTarget.classList.contains("hidden")) {
      this.searchTarget.focus()
    }
  }

  close(event) {
    if (!this.element.contains(event.target)) {
      this.dropdownTarget.classList.add("hidden")
    }
  }

  filter() {
    const query = this.searchTarget.value.toLowerCase()
    this.optionTargets.forEach(option => {
      const name = (option.dataset.iconName || "").toLowerCase()
      option.classList.toggle("hidden", !name.includes(query))
    })
  }

  select(event) {
    event.preventDefault()
    const iconName = event.currentTarget.dataset.iconName || ""
    this.selected = iconName
    this.inputTarget.value = iconName

    // Update preview visibility
    this.previewTargets.forEach(preview => {
      const isMatch = preview.dataset.iconName === iconName
      preview.classList.toggle("hidden", !isMatch)
    })

    // Show/hide placeholder
    const placeholder = this.element.querySelector("[data-placeholder]")
    if (placeholder) {
      placeholder.classList.toggle("hidden", iconName !== "")
    }

    this.dropdownTarget.classList.add("hidden")
    this.searchTarget.value = ""
    this.filter()
  }
}
